module.exports = __webpack_public_path__ + "static/media/fire.b14b7144.jpeg";